
export default {
  name: 'MobileSearchPanel',

  props: {
    openDrawer: {
      type: Boolean,
      default: false
    },
    totalResults: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      mobileFilters: false,
      mobileSearch: false,
      showFiltersChip: true
    }
  },

  computed: {
    howManyFiltersFilled() {
      return Object.keys(this.$route.query).filter((key) => key !== 'page').length
    },
    filterFilledIcon() {
      return this.howManyFiltersFilled
        ? `$vuetify.icons.mdiNumeric${this.howManyFiltersFilled}BoxMultipleOutline`
        : ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        this.checkTab(newTab)
      },
      immediate: true
    },
    openDrawer: {
      handler(newVal) {
        if (newVal) {
          console.log('mobileFilters', this.mobileFilters, this.openDrawer)
          this.mobileFilters = true
        }
      }
    }
  },

  mounted() {
    this.resizeCallback()
    this.checkTab(this.$route.query.tab)
  },

  methods: {
    resizeCallback() {
      const sizeType = this.$resizeType()
      this.mobileSearch = sizeType.mobile
    },
    checkTab(tab) {
      this.showFiltersChip = !(tab === 'invitations' || tab === 'applications')
    }
  }
}
